import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({
    as = "div",
    delay = 0,
    className,
    children,
    ...rest
}) => {
    const reduce = useReducedMotion();
    const Component = motion[as] || motion.div;
    return (
        <Component
            className={className}
            initial={reduce ? false : { opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: "easeOut", delay }}
            {...rest}
        >
            {children}
        </Component>
    );
};
